/**
 * Planning event types for real-time notifications.
 */
export enum PlanningEventType {
  CREATED = 'planning:task-created',
  UPDATED = 'planning:task-updated',
  DELETED = 'planning:task-deleted',
}

/**
 * Payload for planning events.
 */
export interface PlanningEvent {
  type: PlanningEventType;
  taskId: string;
  ownerId: string;
  data: Record<string, unknown>;
  timestamp: string;
}

/**
 * Pub/sub channel for planning events.
 */
export const PLANNING_EVENTS_CHANNEL = 'planning:events';

/**
 * WebSocket room for planning updates.
 */
export const PLANNING_UPDATES_ROOM = 'planning:updates';
